import React, {ChangeEvent, MouseEvent} from "react";
import {
  Button,
  InputAdornment,
  ListItemText,
  Menu,
  MenuItem,
  OutlinedInput,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import {FilterList} from "@material-ui/icons";
import {
  SortOption,
  sortOptions,
} from "view/EmbeddedShows/helpers/filterSortReducer";
import FlexRow from "view/components/Layout/FlexRow";
import {grey} from "@material-ui/core/colors";
import useStyles from "./styles";

type Props = {
  onSearch: (e: ChangeEvent<HTMLInputElement>) => void;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  sortLabel?: string;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onSortChange: (
    value: SortOption["value"]
  ) => (e: MouseEvent<HTMLLIElement>) => void;
};
const SearchBar = ({
  onSearch,
  sortLabel,
  onClose,
  anchorEl,
  onClick,
  onSortChange,
}: Props) => {
  const classes = useStyles();
  return (
    <FlexRow fullWidth gap={0.5}>
      <OutlinedInput
        onChange={onSearch}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon style={{color: grey["500"]}} />
          </InputAdornment>
        }
        className={classes.input}
      />
      <>
        <Button variant="text" onClick={onClick} className={classes.sortButton}>
          <FilterList style={{marginRight: 4}} />
          {sortLabel}
        </Button>
        <Menu
          id="customized-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={onClose}
          PaperProps={{
            style: {
              maxHeight: 48 * 4.5,
              width: "200px",
            },
          }}
        >
          {sortOptions.map((option) => (
            <MenuItem key={option.label} onClick={onSortChange(option.value)}>
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Menu>
      </>
    </FlexRow>
  );
};

export default SearchBar;
